import React, {useContext, useEffect} from 'react';
import {useKeycloak} from '@react-keycloak/web';
import {useIntl} from 'react-intl';
import {useNavigate, useParams} from 'react-router-dom';

import {Button, message, Space, Tabs} from 'antd';
import {IoArrowBackOutline} from 'react-icons/all';
import AppPageMetadata from '@crema/core/AppPageMetadata';
import AppsContainer from '@crema/core/AppsContainer';
import AppsHeader from '@crema/core/AppsContainer/AppsHeader';
import AppsContent from '@crema/core/AppsContainer/AppsContent';
import {PractitionerContext, Provider} from '../PractitionerContext';
import {handleError} from 'utils/MessageUtils';
import {findPractitionerById} from 'services/PractitionerService';
import PractitionerInfo from './PractitionerInfo';
import RoleList from './RoleList';
import CertificateList from './Certificates/CertificateList';
import MethodList from './Methods/MethodList';

const DetailTab = () => {
  const {keycloak} = useKeycloak();
  const intl = useIntl();
  const {id} = useParams();
  const navigate = useNavigate();

  const headers = {
    Authorization: `Bearer ${keycloak?.token}`,
    'Accept-Language': intl.locale,
  };

  const practitionerContext = useContext(PractitionerContext);
  const {selectedPractitioner, setSelectedPractitioner} = practitionerContext;

  useEffect(() => {
    if (id) {
      findPractitionerById(headers, id)
        .then((res) => {
          setSelectedPractitioner(res.data);
        })
        .catch((error) => handleError(message, error));
    }
  }, [id]);

  return (
    <>
      <AppPageMetadata title={intl.messages['common.detail']} />
      <AppsContainer
        title={intl.messages['practitioner.info']}
        fullView
        type='bottom'>
        <AppsHeader key={'header'}>
          <div className='customer-header'>
            <div className='customer-header-input-view'>
              <Button
                type='primary'
                shape='circle'
                ghost
                icon={<IoArrowBackOutline />}
                onClick={() => navigate('/health/practitioners')}
              />
            </div>
          </div>
        </AppsHeader>

        <AppsContent
          key={'content'}
          style={{
            paddingTop: 10,
            paddingBottom: 10,
          }}>
          <Space
            direction='vertical'
            style={{width: '100%', paddingLeft: 10, paddingRight: 10}}>
            <Tabs defaultActiveKey='1' destroyInactiveTabPane={true}>
              <Tabs.TabPane tab={intl.messages['common.detail']} key='detail'>
                <PractitionerInfo />
              </Tabs.TabPane>
              <Tabs.TabPane
                tab={intl.messages['practitioner.employmentHistory']}
                key='organizations'>
                <RoleList />
              </Tabs.TabPane>
              <Tabs.TabPane
                tab={intl.messages['practitioner.certificates']}
                key='certificates'>
                <CertificateList practitioner={selectedPractitioner} />
              </Tabs.TabPane>
              <Tabs.TabPane
                tab={intl.messages['practitioner.methods']}
                key='methods'>
                <MethodList practitioner={selectedPractitioner} />
              </Tabs.TabPane>
            </Tabs>
          </Space>
        </AppsContent>
      </AppsContainer>
    </>
  );
};

export default function PractitionerDetail() {
  return (
    <Provider>
      <DetailTab />
    </Provider>
  );
}
